<mat-form-field
  class="search-input"
  [ngClass]="cssClass"
  [style]="{ width: inputWidth }"
  appearance="outline"
>
  <i
    class="icon-search text-ui-gray-light text-2xl"
    matPrefix
  ></i>
  <input
    type="text"
    (blur)="blurEvent()"
    (ngModelChange)="modelChange($event)"
    [(ngModel)]="inputValue"
    [value]="inputValue"
    #input
    matInput
    placeholder="{{ placeholder }}"
  />
  @if (input.value) {
    <button
      class="test-clear-button"
      (click)="clear()"
      aria-label="Clear"
      data-cy="clear-search-input"
      mat-icon-button
      matSuffix
    >
      <i class="icon-close text-ui-dark text-3xl"></i>
    </button>
  }

</mat-form-field>
